export const playerDevelopment = [
  {
    id: "guards",
    group: "Positions",
    title: "Guards",
    summary: "Lead the team — handle, pace, and decision-making.",
    drills: ["Two-ball handling circuit", "Pick & roll reads", "Pace-change finishes"],
    progressions: ["Stationary → on-move → live read", "1v0 → 1v1 → 2v2 reads"],
    notes: "Guards set the tone. Prioritize change of pace, vision, and protecting the basketball under pressure.",
  },
  {
    id: "wings",
    group: "Positions",
    title: "Wings",
    summary: "Two-way versatility — shoot, attack closeouts, defend multiple spots.",
    drills: ["Catch-and-shoot off relocation", "Closeout attacks", "Wing isolation reads"],
    progressions: ["Spot shooting → off movement → off the dribble", "Drive-kick-drive decisions"],
    notes: "Wings must be reliable from three and decisive attacking closeouts. Defensively, guard 1 through 4.",
  },
  {
    id: "bigs",
    group: "Positions",
    title: "Bigs",
    summary: "Anchor the defense, finish efficiently, and screen with intent.",
    drills: ["Mikan series", "Short-roll reads", "Drop-coverage footwork"],
    progressions: ["Finishing → contact finishing → reads", "Screening angles → short roll → playmaking"],
    notes: "Bigs protect the paint and set hard, legal screens. Develop a reliable finish and short-roll passing.",
  },
  {
    id: "shooting",
    group: "Skills",
    title: "Shooting",
    summary: "Build clean, repeatable, game-speed mechanics.",
    drills: ["Form shooting", "Catch-and-shoot spacing", "Off-the-dribble pull-ups"],
    progressions: ["Form → set shot → game shots → contested"],
    notes: "Footwork and balance first, then volume. Track makes and game-shot reps, not just total shots.",
  },
  {
    id: "passing",
    group: "Skills",
    title: "Passing",
    summary: "Deliver on time, on target, and with intent.",
    drills: ["Partner passing under pressure", "Skip-pass reads", "Pocket & lob from ball screens"],
    progressions: ["Stationary → on-move → live reads"],
    notes: "The pass that leads to the assist matters. Teach players to pass teammates open, not just to them.",
  },
  {
    id: "finishing",
    group: "Skills",
    title: "Finishing",
    summary: "Score through length and contact at the rim.",
    drills: ["Mikan & reverse Mikan", "Floaters & runners", "Contact finishes"],
    progressions: ["Touch → both hands → through contact → reads"],
    notes: "Develop both hands, the in-between game, and the ability to absorb contact and finish.",
  },
  {
    id: "defense",
    group: "Skills",
    title: "Defense",
    summary: "Pressure, contain, help, and contest.",
    drills: ["Closeout & contest", "Shell drill", "1v1 containment"],
    progressions: ["Stance → slides → live containment → team help"],
    notes: "Defense is effort plus discipline. Build pride in stops and connected team rotations.",
  },
  {
    id: "basketball-iq",
    group: "Skills",
    title: "Basketball IQ",
    summary: "See the game a step ahead.",
    drills: ["Film walkthroughs", "Advantage-disadvantage play", "Read & react games"],
    progressions: ["Concept → walkthrough → live application"],
    notes: "Teach the why behind every action. Smart players make the right read, not just the athletic play.",
  },
  {
    id: "strength-conditioning",
    group: "Performance",
    title: "Strength & Conditioning",
    summary: "Build a durable, explosive, game-ready body.",
    drills: ["Foundational lifts", "Plyometric progressions", "Sprint conditioning"],
    progressions: ["Movement quality → load → power → capacity"],
    notes: "Train movement before load. Build athletes who are strong, explosive, and resistant to injury.",
  },
  {
    id: "mobility",
    group: "Performance",
    title: "Mobility",
    summary: "Move freely and stay healthy.",
    drills: ["Hip & ankle mobility flows", "Dynamic warm-ups", "Movement prep"],
    progressions: ["Daily mobility → targeted work → integrated movement"],
    notes: "Mobility unlocks performance and protects against injury. Make it a daily non-negotiable.",
  },
  {
    id: "recovery",
    group: "Performance",
    title: "Recovery",
    summary: "Train hard, recover smart.",
    drills: ["Sleep routines", "Active recovery", "Mobility & breathing"],
    progressions: ["Awareness → habits → monitoring"],
    notes: "Adaptation happens during recovery. Sleep, hydration, and load management are part of training.",
  },
  {
    id: "nutrition",
    group: "Performance",
    title: "Nutrition",
    summary: "Fuel performance and growth.",
    drills: ["Game-day fueling plan", "Hydration habits", "Recovery nutrition"],
    progressions: ["Education → habits → consistency"],
    notes: "You can't out-train poor fueling. Build simple, sustainable habits that support performance.",
  },
];
